var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIphoneIconFive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4167 47.9167H64.5833V35.4167H35.4167V47.9167ZM68.75 33.3333V66.6667C68.75 67.2192 68.5305 67.7491 68.1398 68.1398C67.7491 68.5305 67.2192 68.75 66.6667 68.75H33.3333C32.7808 68.75 32.2509 68.5305 31.8602 68.1398C31.4695 67.7491 31.25 67.2192 31.25 66.6667V33.3333C31.25 32.7808 31.4695 32.2509 31.8602 31.8602C32.2509 31.4695 32.7808 31.25 33.3333 31.25H66.6667C67.2192 31.25 67.7491 31.4695 68.1398 31.8602C68.5305 32.2509 68.75 32.7808 68.75 33.3333ZM64.5833 52.0833H35.4167V64.5833H64.5833V52.0833ZM39.5833 56.25H45.8333V60.4167H39.5833V56.25ZM39.5833 39.5833H45.8333V43.75H39.5833V39.5833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneIconFive);
export default __webpack_public_path__ + "static/media/iphone-icon-five.0a0ee3667a5cc8572869c7500eff58fd.svg";
export { ForwardRef as ReactComponent };